import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Shield } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  if (user && user.role === 'superadmin') { navigate('/admin/dashboard'); return null; }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Logout any existing session first
      try { await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`, {}, { withCredentials: true }); } catch {}
      const u = await login(email, password);
      if (u.role !== 'superadmin') {
        toast.error('Access denied. Super admin credentials required.');
        return;
      }
      navigate('/admin/dashboard');
    } catch {
      toast.error('Invalid credentials');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#1A2421] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-[#556B2F] flex items-center justify-center">
            <Shield size={28} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Outfit' }}>Apptio Platform</h1>
          <p className="text-sm text-[#8B9A6B] mt-1">Administration Portal</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4 bg-[#232F2B] rounded-2xl p-6 border border-[#2D3B36]">
          <div className="space-y-2">
            <Label className="text-[#8B9A6B] text-xs uppercase tracking-wider">Email</Label>
            <Input type="email" value={email} onChange={e => setEmail(e.target.value)} required className="bg-[#1A2421] border-[#2D3B36] text-white placeholder:text-[#4A5D4A]" placeholder="admin@apptio.com" data-testid="admin-email" />
          </div>
          <div className="space-y-2">
            <Label className="text-[#8B9A6B] text-xs uppercase tracking-wider">Password</Label>
            <Input type="password" value={password} onChange={e => setPassword(e.target.value)} required className="bg-[#1A2421] border-[#2D3B36] text-white placeholder:text-[#4A5D4A]" data-testid="admin-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#556B2F] hover:bg-[#4A5D23] text-white py-5 font-semibold" data-testid="admin-login-btn">
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>
        <p className="text-center text-xs text-[#4A5D4A] mt-6">Restricted access. Authorized personnel only.</p>
      </div>
    </div>
  );
}
